<template>
  <el-dialog title="出车确认" :visible.sync="dialogVisible" width="600px">
    <el-form ref="form" label-position="top" label-width="80px" :model="form">
      <el-form-item
        label="确认人工出车吗？请输入原因："
        prop="outward_reason"
        :rules="[{ required: true, message: '请输入原因', trigger: 'blur' }]"
      >
        <el-input
          placeholder="请输入原因"
          :autosize="{ minRows: 4, maxRows: 6 }"
          type="textarea"
          v-model="form.outward_reason"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      dialogVisible: false
    };
  },
  methods: {
    onOpen(booking_id) {
      this.form.booking_id = booking_id;
      this.dialogVisible = true;
    },
    onConfirm() {
      this.$refs.form.validate(async v => {
        if (v) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/outward",
              data: this.form
            });
            this.dialogVisible = false;
          } catch (error) {
            console.log(error);
          }
          this.$emit("ok");
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px !important;
}
</style>